import type * as Types from '@xingternal/pages-graphql-types';

import * as Operations from './EntityPageFollowMutation.graphql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type EntityPageFollowMutationVariables = Types.Exact<{
  followedId: Types.Scalars['ID']['input'];
}>;


export type EntityPageFollowMutation = (
  { __typename?: 'Mutation' }
  & { entityPageFollow?: Types.Maybe<(
    { __typename?: 'FollowersMutationResult' }
    & { error?: Types.Maybe<(
      { __typename?: 'FollowersFollowError' }
      & Pick<Types.FollowersFollowError, 'message'>
    )> }
  )> }
);


export type EntityPageFollowMutationFn = Apollo.MutationFunction<EntityPageFollowMutation, EntityPageFollowMutationVariables>;

/**
 * __useEntityPageFollowMutation__
 *
 * To run a mutation, you first call `useEntityPageFollowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEntityPageFollowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [entityPageFollowMutation, { data, loading, error }] = useEntityPageFollowMutation({
 *   variables: {
 *      followedId: // value for 'followedId'
 *   },
 * });
 */
export function useEntityPageFollowMutation(baseOptions?: Apollo.MutationHookOptions<EntityPageFollowMutation, EntityPageFollowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EntityPageFollowMutation, EntityPageFollowMutationVariables>(Operations.EntityPageFollow, options);
      }
export type EntityPageFollowMutationHookResult = ReturnType<typeof useEntityPageFollowMutation>;
export type EntityPageFollowMutationResult = Apollo.MutationResult<EntityPageFollowMutation>;
export type EntityPageFollowMutationOptions = Apollo.BaseMutationOptions<EntityPageFollowMutation, EntityPageFollowMutationVariables>;